import { render, staticRenderFns } from "./audience-table.vue?vue&type=template&id=18fed0ce&"
import script from "./audience-table.vue?vue&type=script&lang=js&"
export * from "./audience-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports